import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as R from 'ramda'

class FormaterPick extends Component {
  /*static propTypes = {
      value: PropTypes.string||PropTypes.number
    };*/
    constructor(props) {
      super(props);
      let viewValue = this.props.value
      let mPick = this.props.Pick
      //console.log('this.props.Pick-----',mPick);
      //console.log('this.props.value-----',viewValue);
      try {
        if (this.props.Pick)
          viewValue = mPick[viewValue-1]['title']
        else
          viewValue = this.props.value
      }
      catch(e)
      {
        viewValue = this.props.value
      }
     // console.log('viewValue------',viewValue);   
      this.state = {
        curvalue: viewValue
      }
      this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps) {
      return nextProps.value !== this.props.value;
    }

    handleChange = date => 
      this.setState({
        startDate: date
      });
    

    render() { 
      let viewValue = this.props.value
      let mPick = this.props.Pick
      try {
        if (this.props.Pick){
          let rowPick = R.find(R.propEq('pkid', viewValue))(this.props.Pick) 
          if (rowPick)
            viewValue = rowPick['title']
        }
        else
          viewValue = this.props.value
      }
      catch(e)
      {
        viewValue = this.props.value
      }
     // return <div style = {{textAlign : this.props.Align,color : this.props.Color}} title={this.state.curvalue}>{this.state.curvalue}</div>;
      return <div style = {{textAlign : this.props.Align,color : this.props.Color}}>{viewValue}</div>;
    }
  }

  export default FormaterPick;  